import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

import { OccupationCard } from '@cpd-app/generated';
import { MATCH_DIMENSIONS } from '@cpd-app/shared-module/constants';

@Component({
  selector: 'cpd-occupation-scores-info',
  templateUrl: './occupation-scores-info.component.html',
  styleUrls: ['./occupation-scores-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OccupationScoresInfoComponent implements OnInit {
  @Input() public occupation: OccupationCard & {
    typicalWorkExperienceGroup?: string;
  };
  @Input() public showTitle = true;

  /**
   * Built from the one shared list of dimensions rather than a local copy of
   * it, and the value is the match quality's own id: the template names it
   * through the matchQuality pipe, because a match is named and never scored.
   */
  public matchScores: { name: string; matchValue: number; color: string }[];

  public ngOnInit(): void {
    this.caclMatchScore();
  }

  public caclMatchScore(): void {
    if (!this.occupation) {
      return;
    }

    this.matchScores = MATCH_DIMENSIONS.map((dimension) => ({
      name: dimension.name,
      matchValue: this.occupation[dimension.scoreKey],
      color: dimension.colorToken
    }));
  }
}
